import React, { useState } from "react";

const sections = [
  {
    title: "1. General Information",
    content:
      "Veth Interiors is an online store providing premium interior products and related items to customers within Nigeria and beyond. By placing an order on our website, you confirm that you are at least 18 years old or have permission from a parent or legal guardian.",
  },
  {
    title: "2. Products & Availability",
    content: null,
    bullets: [
      "Product colors may slightly vary due to screen settings or lighting.",
      "Availability may change without prior notice.",
      "We reserve the right to discontinue or limit products at any time.",
      "All products sold by Veth Interiors are sourced from trusted suppliers and verified international brands.",
    ],
    intro:
      "We strive to ensure all product descriptions, images, and prices displayed on our website are accurate and up to date. However:",
  },
  {
    title: "3. Pricing",
    content: null,
    intro:
      "All prices listed on our website are displayed in Nigerian Naira (₦). While we work hard to maintain stable pricing, product prices may occasionally change due to:",
    bullets: [
      "Supplier costs",
      "Currency exchange rates",
      "Market conditions",
      "Importation expenses",
    ],
    footer: "Customers will always see the final payable amount before completing checkout.",
  },
  {
    title: "4. Orders",
    content: null,
    intro: "Once an order is placed:",
    bullets: [
      "A confirmation email will be sent to the customer.",
      "Orders are processed immediately after payment verification.",
      "Customers are responsible for providing accurate delivery details.",
      "Veth Interiors reserves the right to cancel or reject orders suspected of fraud, misuse, or inaccurate information.",
    ],
  },
  {
    title: "5. Payments",
    content: null,
    intro: "We accept secure payments through trusted payment gateways including:",
    bullets: [
      "Debit/Credit Cards",
      "Bank Transfer",
      "USSD",
      "Mobile Banking",
      "eNaira",
    ],
    footer:
      "All transactions are processed securely through Flutterwave. We do not store customers' banking or card information on our servers.",
  },
  {
    title: "6. Delivery & Shipping",
    content: null,
    intro: "Delivery timelines vary based on customer location and order size.",
    bullets: [
      "Lagos Deliveries: Typically completed within 2–3 hours after confirmation.",
      "Outside Lagos: Delivery may take 1–3 working days depending on location and logistics availability.",
      "Customers are responsible for delivery fees unless otherwise stated.",
      "If a customer misses delivery, the package may be returned to our facility and redelivery may attract additional charges.",
    ],
  },
  {
    title: "7. Order Cancellation",
    content: null,
    intro: "Customers may cancel an order only if:",
    bullets: [
      "The item has not yet been processed or shipped.",
      "Once an order has been dispatched, cancellation may no longer be possible.",
    ],
  },
  {
    title: "8. Returns & Refunds",
    content: null,
    intro: "Returns are only accepted for:",
    bullets: [
      "Damaged items",
      "Defective items",
      "Incorrect items delivered",
    ],
    footer:
      "Complaints must be reported within 3 hours of receiving the package. Items must remain unused and in original condition. Non-returnable items may include luxury items, fragile items, custom orders, and special request products. Refunds are processed within 4–5 working days after inspection and approval. Delivery fees are non-refundable.",
  },
  {
    title: "9. Customer Responsibilities",
    content: null,
    intro: "Customers agree:",
    bullets: [
      "To provide accurate information during checkout",
      "Not to misuse the website",
      "Not to engage in fraudulent transactions",
      "Not to attempt unauthorized access to our systems",
    ],
  },
  {
    title: "10. Intellectual Property",
    content: null,
    intro:
      "All website content including logos, images, product descriptions, designs, and branding remain the property of Veth Interiors and may not be copied or reused without permission.",
  },
  {
    title: "11. Limitation of Liability",
    content: null,
    intro: "Veth Interiors shall not be held liable for:",
    bullets: [
      "Delays caused by third-party logistics providers",
      "Network/payment interruptions",
      "Events beyond our control",
      "Minor variations in product appearance",
    ],
  },
  {
    title: "12. Changes to Terms",
    content:
      "We reserve the right to update or modify these Terms & Conditions at any time without prior notice. Continued use of our website means acceptance of any updated terms.",
  },
  {
    title: "13. Contact Information",
    content: null,
    intro: "For inquiries or support, contact us via:",
    bullets: [
      "Email: support@vethinteriors.com",
      "WhatsApp Support: Available on our Contact Page",
    ],
  },
];

function SectionBlock({ section, index }) {
  const [open, setOpen] = useState(true);

  return (
    <div className="border border-black/10 dark:border-white/10 rounded-2xl overflow-hidden mb-4">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-6 py-4 bg-white dark:bg-black/40 hover:bg-black/5 dark:hover:bg-white/5 transition-colors text-left"
      >
        <h2 className="font-bold text-black/80 dark:text-white/90 text-base sm:text-lg">
          {section.title}
        </h2>
        <span className="text-amber-500 text-xl ml-4 flex-shrink-0">{open ? "−" : "+"}</span>
      </button>

      {open && (
        <div className="px-6 pb-6 pt-2 bg-white dark:bg-black/30 text-black/60 dark:text-white/70 text-sm leading-relaxed">
          {section.intro && <p className="mb-3">{section.intro}</p>}
          {section.content && <p>{section.content}</p>}
          {section.bullets && (
            <ul className="space-y-2 mt-2">
              {section.bullets.map((b, i) => (
                <li key={i} className="flex items-start gap-2">
                  <span className="text-amber-500 flex-shrink-0 mt-0.5">•</span>
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          )}
          {section.footer && <p className="mt-3">{section.footer}</p>}
        </div>
      )}
    </div>
  );
}

const TermsAndConditions = () => {
  return (
    <div className="bg-white dark:bg-black min-h-screen">
      {/* Hero */}
      <div className="w-full pt-32 pb-10 px-4 bg-black/5 dark:bg-white/5 border-b border-black/10 dark:border-white/10">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-black/90 dark:text-white mb-3">
            Terms &amp; Conditions
          </h1>
          <p className="text-black/50 dark:text-white/50 text-sm">
            Welcome to Veth Interiors. By accessing or using our website, you agree to comply with
            and be bound by the following terms. Please read them carefully.
          </p>
        </div>
      </div>

      {/* Sections */}
      <div className="max-w-3xl mx-auto px-4 py-12">
        {sections.map((section, i) => (
          <SectionBlock key={i} section={section} index={i} />
        ))}

        {/* Contact CTA */}
        <div className="mt-8 bg-black/5 dark:bg-white/5 rounded-2xl p-8 text-center border border-black/10 dark:border-white/10">
          <h3 className="text-lg font-bold text-black/90 dark:text-white mb-2">
            Have questions about these terms?
          </h3>
          <p className="text-black/50 dark:text-white/50 text-sm mb-4">
            Our support team is available to help.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="https://wa.me/2348106079897"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-3 bg-green-600 hover:bg-green-700 text-white font-bold rounded-full transition-all"
            >
              WhatsApp Us
            </a>
            <a
              href="mailto:support@vethinteriors.com"
              className="px-8 py-3 border-2 border-amber-500 text-amber-600 dark:text-amber-400 font-bold rounded-full hover:bg-amber-500 hover:text-white transition-all"
            >
              Email Support
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
